const state = {
  cashiers: [],
  cashier: {},
  trashedCashiers: [],
}
export default state
